import ApplicationModal from './ApplicationModal';

export default ApplicationModal;
